import {Stack} from '@mui/material'
import React, {useEffect, useState} from 'react'
import Tabs from './Tabs'
import IDoNotHaveAccountsInStoresForm from './IDoNotHaveAccountsInStoresForm'
import IHaveAccountsInStoresForm from './IHaveAccountsInStoresForm'
import IHaveAftterSubmit from './IHaveAftterSubmit'
import AppMaker from '../../../Api/AppMaker'
import Loading from '../../customTable/LoadingForm'
import Label from '../../customTable/Label'
import NoNetWork from '../../customTable/NoNetWork'

export default function ActiveForm({android}: any) {
  const [active, setActive] = useState(1)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isLoading, setIsLoading] = useState(!false)
  const [data, setData] = useState<any>({check: 1})
  const [isCompleteed, setIsCompleteed] = useState(false)
  useEffect(() => {
    setIsSubmit(false)
  }, [android])
  useEffect(() => {
    AppMaker.get(
      android,
      (res: any) => {
        console.log(res)
        if (!res.ErrorStatus) {
          setData({...res.data, check: res.data.vendor_type === 'resident' ? 0 : 1})
          setActive(res.data?.is_have_account ? 1 : 2)
          setIsSubmit(true)
        }
      },
      setIsLoading
    )
  }, [android, isCompleteed])
  return (
    <NoNetWork>
      <Stack width={'100%'} minHeight={'80vh'} position={'relative'}>
        {isLoading ? (
          <Loading />
        ) : (
          <Stack>
            {isSubmit && active === 1 ? (
              <IHaveAftterSubmit
                setData={setData}
                setIsSubmit={setIsSubmit}
                data={data}
                android={android}
              />
            ) : isSubmit && active !== 1 ? (
              <IHaveAftterSubmit
                setData={setData}
                setIsSubmit={setIsSubmit}
                data={data}
                android={android}
                IDontHave
              />
            ) : (
              <></>
            )}
            {!isSubmit && (
              <>
                {' '}
                <Tabs active={active} setActive={setActive} />
                <>
                  {data.reject_reason && (
                    <>
                      <Stack mt='24px' p='8px' border='1px dashed red' bgcolor={'#fbe8e9'}>
                        <Label fs='12px' color={'#ff0e00'} text={data?.reject_reason} />
                      </Stack>
                    </>
                  )}
                  {active !== 1 ? (
                    <IDoNotHaveAccountsInStoresForm
                      data={data}
                      setData={setData}
                      active={active}
                      android={android}
                      setIsSubmit={setIsSubmit}
                      setIsCompleteed={setIsCompleteed}
                      isCompleteed={isCompleteed}
                    />
                  ) : (
                    <IHaveAccountsInStoresForm
                      data={data}
                      active={active}
                      setData={setData}
                      android={android}
                      setIsSubmit={setIsSubmit}
                      setIsCompleteed={setIsCompleteed}
                      isCompleteed={isCompleteed}
                    />
                  )}
                </>
              </>
            )}
          </Stack>
        )}
      </Stack>
    </NoNetWork>
  )
}
